import { currentSiteId } from "scrivito"
import { LANDING } from "shared/constants/permalinks"
import { GLOBAL_SEARCH_OVERLAY } from "shared/context/overlay/types"
import { useAuth } from "shared/lib/useAuth"
import { useOverlay } from "shared/lib/useOverlay"

import { useActiveProjectSelectModel } from "widgets/header/active-project-select/hooks/useActiveProjectSelectModel"

import { HeaderModel } from "../Header"
import { useHeaderMenuButtonModel } from "./useHeaderMenuButtonModel"
import { usePortalStage } from "./usePortalStage"

export function useHeaderModel(): HeaderModel {
  const { isAuthenticated } = useAuth()
  const portalStage = usePortalStage()

  const projectContextSelectModel = useActiveProjectSelectModel()
  const menuButtonModel = useHeaderMenuButtonModel()
  const { openOverlay: openGlobalSearch } = useOverlay(GLOBAL_SEARCH_OVERLAY)

  return {
    logoLinkProps: {
      href: "/",
      clickHref: `/${currentSiteId()}/${LANDING}`
    },
    menuButtonProps: menuButtonModel,
    projectContextSelectModel,
    portalStage,
    isAuthenticated,
    openGlobalSearch: () => openGlobalSearch(null)
  }
}
